import type { RouteObject } from 'react-router';

import { ConnectedPartners } from './pages/ConnectedPartners/ConnectedPartners';
import { IntegrationRequest } from './pages/IntegrationRequest/IntegrationRequest';
import { LinkYourSoftware } from './pages/LinkYourSoftware/LinkYourSoftware';
import { TermsOfUse } from './pages/TermsOfUse/TermsOfUse';

export const routes: RouteObject[] = [
  {
    path: 'link-your-software',
    element: <LinkYourSoftware slug="Link your software" />,
  },
  {
    path: 'connected-partners',
    element: <ConnectedPartners slug="Connected Partners" />,
  },
  {
    path: 'integration-request',
    element: <IntegrationRequest slug="Integration Request" />,
  },
  {
    path: 'terms-of-use',
    element: <TermsOfUse slug="Terms of Use" />,
  },
];
